var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 0.5C2.165 0.5 1.9875 0.5725 1.8425 0.717501C1.6975 0.8625 1.625 1.04 1.625 1.25V2.75H3.125V2H13.625V14H3.125V13.25H1.625V14.75C1.625 14.96 1.6975 15.1375 1.8425 15.2825C1.9875 15.4275 2.165 15.5 2.375 15.5H14.375C14.585 15.5 14.7625 15.4275 14.9075 15.2825C15.0525 15.1375 15.125 14.96 15.125 14.75V1.25C15.125 1.04 15.0525 0.8625 14.9075 0.717501C14.7625 0.5725 14.585 0.5 14.375 0.5H2.375ZM6.125 11C6.125 10.59 6.225 10.2125 6.425 9.8675C6.625 9.5225 6.8975 9.25 7.2425 9.05C7.5875 8.85 7.965 8.75 8.375 8.75C8.785 8.75 9.1625 8.85 9.5075 9.05C9.8525 9.25 10.125 9.5225 10.325 9.8675C10.525 10.2125 10.625 10.59 10.625 11H6.125ZM8.375 8C8.105 8 7.855 7.9325 7.625 7.7975C7.395 7.6625 7.2125 7.48 7.0775 7.25C6.9425 7.02 6.875 6.77 6.875 6.5C6.875 6.23 6.9425 5.98 7.0775 5.75C7.2125 5.52 7.395 5.3375 7.625 5.2025C7.855 5.0675 8.105 5 8.375 5C8.645 5 8.895 5.0675 9.125 5.2025C9.355 5.3375 9.5375 5.52 9.6725 5.75C9.8075 5.98 9.875 6.23 9.875 6.5C9.875 6.77 9.8075 7.02 9.6725 7.25C9.5375 7.48 9.355 7.6625 9.125 7.7975C8.895 7.9325 8.645 8 8.375 8ZM3.875 5.75V4.25H0.875V5.75H3.875ZM3.875 7.25V8.75H0.875V7.25H3.875ZM3.875 11.75V10.25H0.875V11.75H3.875Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.4308cd33cf144e40bef7aba0dc215738.svg";
export { ForwardRef as ReactComponent };